import React from "react";
import type { HeroProps } from "../types";
import Image from "next/image";

const VerifiedCertificates = ({
  title,
  image,
}: Pick<HeroProps, "image" | "title">) => {
  return (
    <div className="w-full">
      <div className="py-0 w-full">
        <div className="bg-primary border-brand border-b-4 mb-5 overflow-hidden py-5 px-5 w-full ">
          <div className="w-full grid grid-cols-1 p-1 content-center sm:grid-cols-2 container">
            <div className="xl:p-4">
              <h1 className="text-4xl text-white font-bold">{title}</h1>
            </div>
            {image?.sourceUrl ? (
              <div className="block w-full max-h-fit relative">
                <Image
                  layout="responsive"
                  priority={true}
                  src={image.sourceUrl}
                  alt={image.altText || ""}
                  width={150}
                  height={150}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifiedCertificates;
